import {
	SIMILAR_PRODUCTS_PAGE_SIZE,
	useSimilarProductsContext,
} from './ProductDetailsContext';
import ProductDetailsProductList from './ProductDetailsProductList';

interface Props {
	className?: string;
	heading: string;
	loadMoreButtonText: string;
	productId: string;
}

export default function ProductDetailsSimilarProducts({
	className,
	heading,
	loadMoreButtonText,
	productId,
}: Props) {
	const {
		hasNextPage,
		isLoading,
		isLoadingMore,
		items: similarProducts,
		loadMore,
	} = useSimilarProductsContext();

	return (
		<ProductDetailsProductList
			className={className}
			gtmItemListId="pdp_similar_products"
			gtmItemListName={`List: Similar products ${productId}`}
			heading={heading}
			isLoading={isLoading}
			products={similarProducts}
			onLoadMore={loadMore}
			loadMoreButtonText={loadMoreButtonText}
			// It should only be possible to load one extra page
			hasLoadMoreButton={
				hasNextPage && similarProducts.length <= SIMILAR_PRODUCTS_PAGE_SIZE
			}
			isLoadingMore={isLoadingMore}
		/>
	);
}
ProductDetailsSimilarProducts.displayName = 'ProductDetailsSimilarProducts';
